var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMintdao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 748.618 591.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57bd99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a6fb",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M731.344 172.61C695.266 84.582 614.791 25.372 610.423 22.212L579.751 0l-30.668 22.212c-3.747 2.714-63.431 46.649-103.124 114.609a275.823 275.823 0 0 0-23.417 50.913c14.114 15.4 29.012 34.209 41.27 55.569 15.542 27.072 26.827 58.205 26.827 91.546 0 4.328-.255 8.6-.62 12.855-1.982 23.087-9.088 44.952-18.924 64.955-33.179 67.5-97.015 113.781-97.015 113.781s-63.611-46.112-96.842-113.434c-9.829-19.908-16.962-41.666-19.03-64.646-.409-4.469-.687-8.959-.687-13.512 0-33.6 11.469-64.972 27.2-92.208 12.281-21.254 27.152-39.962 41.219-55.262a276.521 276.521 0 0 0-23.464-50.845C262.786 68.746 203.259 24.92 199.519 22.212L168.847 0l-30.668 22.212C132.537 26.293 0 123.8 0 256.149c0 40.7 12.556 78.085 30.075 110.483h61.01c-21.365-31.064-38.794-69.059-38.794-110.483 0-107.184 116.555-191.586 116.555-191.586s63.611 46.118 96.842 113.428c-31.449 40.663-60.461 94.943-60.461 156.86a213.873 213.873 0 0 0 11.755 68.773 276.217 276.217 0 0 0 23.466 50.846c39.693 67.8 99.22 111.617 102.963 114.325L374.079 591l30.67-22.2c3.747-2.708 63.431-46.656 103.124-114.611a275.475 275.475 0 0 0 23.417-50.917 213.724 213.724 0 0 0 11.638-68.414c0-61.737-28.843-115.878-60.19-156.507 33.179-67.507 97.015-113.781 97.015-113.781s60.287 43.651 94.147 108.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M731.343 172.61H673.9c13.2 25.124 22.431 53.771 22.431 83.843 0 41.426-17.434 79.42-38.8 110.484h61.013c17.52-32.4 30.075-69.783 30.075-110.484 0-29.819-6.786-58.231-17.274-83.843"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintdao);
export default __webpack_public_path__ + "static/media/mintdao.d7939eb091efabc71a098911ab014f3f.svg";
export { ForwardRef as ReactComponent };